/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react'
import { useParams } from 'react-router-dom';

/** Utilities */
import { decryptUrlData } from '../../../services/CryptoService';
import { setDropdownOptions } from '../../../components/finalForms/libs/mapDropdownOptions';
import { setFieldSetting } from '../../../utils/FormFields/FieldsSetting/SetFieldSetting';
import { FieldSettingType } from '../../../utils/Enums/commonEnums';

/** Common Components */
import FormCreator from '../../../components/finalForms/FormCreator';
import CardSection from '../../../components/ui/card/CardSection';
import FinalMolGrid from '../../../components/FinalMolGrid/FinalMolGrid';
import Buttons from '../../../components/ui/button/Buttons';

/** Common Services & Data Files */
import { AppIcons } from '../../../data/appIcons';
import ToastService from '../../../services/toastService/ToastService';
import SwalAlert from '../../../services/swalService/SwalService';

/** Configuration Files */
import { GroupMembersGridConfig, groupMembersData } from '../config/GroupMembers.data';

/** RTK Query */
import { 
    useAddGroupMemberMutation, 
    useDeleteGroupMemberMutation, 
    useLazyGetGroupMemberByGroupIdQuery, 
    useLazyGetUnassignGroupMembersbyGroupIdQuery 
} from '../../../app/services/groupMemberAPI';

const GroupMembers = () => {
    
    const groupMemberRef = useRef();
    const groupMemberFormRef = useRef();
    const { confirm } = SwalAlert();

    const { id } = useParams();
    const groupId = id ? decryptUrlData(id) : null;

    const [groupMemberForm, setGroupMemberForm] = useState(groupMembersData);
    const [dataSource, setDataSource] = useState([]);

    const [addGroupMember, {
        isSuccess: isaddGroupMemberSuccess,
        data: addGroupMemberData
    },
    ] = useAddGroupMemberMutation();

    const [getGroupMemberByGroupId, {
        isLoading: isGroupMemberByGroupIdLoading,
        isSuccess: isGroupMemberByGroupIdSuccess,
        data: GroupMemberByGroupIdData
    },
    ] = useLazyGetGroupMemberByGroupIdQuery();

    const [deleteGroupMember, {
        isSuccess: isdeleteGroupMemberSuccess,
        data: GroupMemberData
    },
    ] = useDeleteGroupMemberMutation();

    const [getUnassignGroupMembersbyGroupId, {
        isLoading: isUnassignGroupMembersbyGroupIdLoading,
        isSuccess: isUnassignGroupMembersbyGroupIdSuccess,
        data: UnassignGroupMembersbyGroupIdData
    },
    ] = useLazyGetUnassignGroupMembersbyGroupIdQuery()

    useEffect(() => {
        if (groupId) {
            getGroupMemberByGroupId(groupId);
            getUnassignGroupMembersbyGroupId(groupId);
        }
    }, [groupId])

    useEffect(() => {
        if (isaddGroupMemberSuccess && addGroupMemberData) {
            if (addGroupMemberData.errorMessage.includes("exists")) {
                ToastService.warning(addGroupMemberData.errorMessage);
                return;
            }
            else {
                ToastService.success(addGroupMemberData.errorMessage);
                getGroupMemberByGroupId(groupId);
                getUnassignGroupMembersbyGroupId(groupId);
                resetForm();
               setFieldSetting(groupMemberForm, 'groupMember', FieldSettingType.ISFIELDDATALOADING, true);
            }
        }
    }, [isaddGroupMemberSuccess, addGroupMemberData])

    useEffect(() => {
        if(!isGroupMemberByGroupIdLoading && isGroupMemberByGroupIdSuccess && GroupMemberByGroupIdData){
            setDataSource(GroupMemberByGroupIdData);
        }
    }, [isGroupMemberByGroupIdLoading, isGroupMemberByGroupIdSuccess, GroupMemberByGroupIdData])

    useEffect(() => {
        if(!isUnassignGroupMembersbyGroupIdLoading && isUnassignGroupMembersbyGroupIdSuccess && UnassignGroupMembersbyGroupIdData){
            setDropdownOptions(UnassignGroupMembersbyGroupIdData, 'userId', 'userName', groupMemberForm, 'groupMember', setGroupMemberForm);
            setFieldSetting(groupMemberForm, 'groupMember', FieldSettingType.ISFIELDDATALOADING, false);
        }
    }, [isUnassignGroupMembersbyGroupIdLoading, isUnassignGroupMembersbyGroupIdSuccess, UnassignGroupMembersbyGroupIdData])

    const onDeleteAction = (data) => {
        confirm(
            "Delete?",
            "Are you sure you want to Delete?",
            "Delete",
            "Cancel"
        ).then((confirmed) => {
            if (confirmed) {
                deleteGroupMember(data?.groupMemberId);
            }
        });
    };

    const resetForm = () => {
        const form = {...groupMembersData}
        form.initialState = {...groupMembersData.initialState}
        setGroupMemberForm(form);
    }

    useEffect(() => {
        if(isdeleteGroupMemberSuccess && GroupMemberData){
            if(GroupMemberData.errorMessage.includes("exists")){
                ToastService.warning(GroupMemberData.errorMessage);
                return;
            }
            else{
                ToastService.success(GroupMemberData.errorMessage);
                getGroupMemberByGroupId(groupId);
                getUnassignGroupMembersbyGroupId(groupId);
                resetForm();
            }
        }
    }, [isdeleteGroupMemberSuccess, GroupMemberData])

    const handleGroupMember = () => {
        const groupMemberData = groupMemberFormRef.current.getFormData();
        if(groupMemberData){
            const userIds = groupMemberData.groupMember.join(",");
            const requestData = {
                userIds: userIds,
                groupId: groupId, 
            };
            addGroupMember(requestData);
        }
    }

    const actionHandler = {
        DELETE: onDeleteAction,
    };

    return (
        <div className='group-member-sec'>
            <CardSection>
                <div className='select-group-member row'>
                    <div className='col-12 d-flex justify-content-between'>
                        <div className='form-card row col-6'>
                            <FormCreator config={groupMemberForm} ref={groupMemberFormRef} />
                        </div>

                        <div className="row mt-3">
                            <div className="form-btn">
                                <Buttons
                                    buttonTypeClassName="theme-btn ml-4 mt-2"
                                    onClick={handleGroupMember}
                                    buttonText="Group Member"
                                    textWithIcon={true}
                                    iconName="material-symbols:add-rounded"
                                    imagePath={AppIcons.AddIcon}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='group-member-grid col-12  team-member-grid'>
                    <FinalMolGrid
                        ref={groupMemberRef}
                        configuration={GroupMembersGridConfig}
                        dataSource={dataSource} 
                        onActionChange = {actionHandler}
                        allowPagination={false}
                        />
                </div>
            </CardSection>
        </div>
    )
}

export default GroupMembers;